module.exports = "<!-- Notebooks list -->\n<div id=\"notebooks\"></div>\n\n<header class=\"list--navbar navbar navbar-default navbar-static-top\">\n    <span class=\"navbar-brand list--brand\">{{ _.i18n('Tags') }}</span>\n    <ul class=\"nav navbar-nav navbar-right header--right list--nav\">\n        <li>\n            <span>\n            <a class=\"btn btn-success\" href=\"#tags/add\" title=\"{{ _.i18n('New tag') }}\">\n                <i class=\"icon-tag\"></i>\n            </a>\n            </span>\n        </li>\n    </ul>\n</header>\n<div id=\"tags\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/notebooks/list/templates/layout.html
// module id = 1307
// module chunks = 0